import Badge from "@edusogno/composites/event-badge";

interface NotificationIconProps {
  variant: NotificationType;
  lessonType?: string;
}

enum NotificationType {
  LESSON_ALERT,
  PLATFORM_ALERT,
}

const NotificationIcon = ({ variant, lessonType }: NotificationIconProps) => {
  return variant === NotificationType.PLATFORM_ALERT ? (
    <svg
      fill="none"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
      height="17"
      viewBox="0 0 16 17"
    >
      <path
        d="M11.3981 6.55145C11.1599 5.55458 10.5239 4.72098 9.62999 4.23402C8.73613 3.74707 7.65763 3.64664 6.63175 3.95484C5.60588 4.26305 4.71665 4.95463 4.1597 5.87745C3.60275 6.80027 3.4237 7.87874 3.66193 8.87561C4.05609 10.5249 3.97955 11.8408 3.73064 12.8406C3.44694 13.9802 3.30509 14.55 3.34341 14.6644C3.38725 14.7953 3.41897 14.8313 3.53526 14.8818C3.6369 14.9259 4.0639 14.7977 4.91789 14.5411L12.8369 12.162C13.6909 11.9054 14.1179 11.7772 14.1862 11.6819C14.2644 11.573 14.2758 11.5241 14.2554 11.3862C14.2376 11.2656 13.8607 10.8517 13.1068 10.0238C12.4453 9.29742 11.7923 8.20079 11.3981 6.55145Z"
        fill="#8065C9"
        opacity="0.12"
      />
      <path
        d="M10.1669 12.9648C10.4531 14.1625 9.81922 15.3935 8.75108 15.7144C7.68294 16.0353 6.58502 15.3245 6.29881 14.1269M1.09724 8.17448C0.837287 7.12819 1.10762 5.997 1.79934 5.23662M7.83118 3.77999C8.03422 3.37044 8.1011 2.87542 7.98439 2.38707C7.74589 1.38906 6.83096 0.796794 5.94084 1.06421C5.05072 1.33163 4.52249 2.35746 4.76099 3.35547C4.8777 3.84382 5.15637 4.23502 5.51484 4.47589M13.2858 4.51271C13.0444 3.46086 12.3058 2.63277 11.3677 2.36205M11.3981 6.5521C11.1599 5.55524 10.5239 4.72163 9.63 4.23468C8.73614 3.74772 7.65764 3.6473 6.63176 3.9555C5.60588 4.2637 4.71666 4.95528 4.15971 5.87811C3.60276 6.80093 3.42371 7.8794 3.66194 8.87626C4.0561 10.5256 3.97956 11.8414 3.73065 12.8413C3.44695 13.9809 3.3051 14.5507 3.34342 14.6651C3.38726 14.796 3.41898 14.8319 3.53527 14.8824C3.63691 14.9266 4.06391 14.7983 4.9179 14.5417L12.8369 12.1627C13.6909 11.9061 14.1179 11.7778 14.1862 11.6826C14.2644 11.5737 14.2759 11.5248 14.2555 11.3868C14.2376 11.2662 13.8607 10.8523 13.1068 10.0244C12.4453 9.29808 11.7923 8.20144 11.3981 6.5521Z"
        stroke="#8065C9"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ) : (
    <Badge
      type={lessonType as string}
      className="border-current border-[1px] rounded-[5px] !w-[70px] !text-xs !h-[25px]"
    />
  );
};

export default NotificationIcon;
